import { useEffect, useRef, useState } from "react";
import Header from "../../../components/header/header";
import "./category.css";
// 引入 ECharts 主模块
import * as echarts from "echarts";
import { Modal, Button, Segmented } from "antd";
import {
  key_cus_header,
  key_cus_list,
  get_expense,
  cus_ml,
} from "../../../api/category";
// import { useNavigate } from "react-router-dom";
// import { Picker} from "../../../components/picker";
import { DatePicker, Mask, SpinLoading } from "antd-mobile";
import { DownOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { watermark } from "../../../utils/watermark";
export default function BrandSpecial() {
  const navigator = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [results, setResults] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const username = queryParams.get("i");
  // const location = useLocation();
  const [param, setParam] = useState({
    headParam: {
      finish_amount: 0,
      guarantee_amount: "0",
      guarantee_percent: "0%",
      target_amount: "0",
      target_percent: "0%",
      time: "",
      total_data: {},
      wpfl_total_data: [],
      finish_weight_percent: "0%",
      xhkc: "0",
    },
    calculationParam: {
      guarantee_amount: "0",
      target_amount: "0",
      ml_data: [],
    },
    bdRList: {
      ml_data: [],
      zzl_data: [],
    },
    rList: {
      ml_data: [],
      zzl_data: [],
    },
    ml_data: [],
    isMb: true,
    isZZ: true,
    isMonthMb: true,
    zml: 0,
    mbP: 0,
    bdP: 0,
    isMb2: true,
    chlZj: 0,
    mlZj: 0,
    syml: 0,
    year: 0,
    month: 0,
    year1: 0,
    month1: 0,
    year2: 0,
    month2: 0,
    year3: 0,
    month3: 0,
    year4: 0,
    month4: 0,
    tyear: 0,
    tmonth: 0,
    pickShow: false,
    touchLength: 0,
    headParam2: {
      finish_amount: 0,
      guarantee_amount: "0",
      guarantee_percent: "0%",
      target_amount: "0",
      target_percent: "0%",
      time: "",
      total_data: {},
      wpfl_total_data: [],
      finish_weight_percent: "0%",
      xhkc: "0",
    },
    headParam3: {
      finish_amount: 0,
      guarantee_amount: "0",
      guarantee_percent: "0%",
      target_amount: "0",
      target_percent: "0%",
      time: "",
      total_data: {},
      wpfl_total_data: [],
      finish_weight_percent: "0%",
      xhkc: "0",
    },
    type: 1, //类型1-品类，2-柜台
  });
  const [maskShow, setMaskShow] = useState(false);
  const [maskShow2, setMaskShow2] = useState(false);
  const [maskShow3, setMaskShow3] = useState(false);
  // const [times, setTimes] = useState("");
  const [types, setTypes] = useState(4);
  const [cusHeader, setCusHeader] = useState({
    month_gross_margin: 0,
    month_profit: 0,
    month_proportion: 0,
    month_target: 0,
    year_gross_margin: 0,
    year_profit: 0,
    year_proportion: 0,
    year_target: 0,
    target_data: [],
  });
  const [cusList, setCuList] = useState({
    total_gross_margin: 0,
    total_shipment_volume: 0,
    total_profit: 0,
    data: [],
  });
  const [cusCateList, setCusCateList] = useState({
    type: "按年",
    cus_name: "",
    data: [],
    total_mjxskz: 0,
    total_mxsml: 0,
  });
  const [mlData, setMlData] = useState([]);
  const [mlTotal, setMlTotal] = useState(0);
  const [mlDjTotal, setMlDjTotal] = useState(0);
  const [items, setItems] = useState({
    shipment_volume: 0,
  });
  const [name, setName] = useState("");
  const [costList, setCostList] = useState([]);
  const [costTotal, setCostTotal] = useState(0);
  const [timeType, setTimeType] = useState("按年");
  const [targetId, settargetId] = useState(1);
  const [salesCost, setSalesCost] = useState("销售明细");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const abortControllerRef = useRef(null);
  const dataFetchedRef = useRef(false);
  // console.info(11111111);
  // getDates();
  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    getDates();
  });
  // const [basicColumns, setBasicColumns] = useState([[]]);
  // 设置最小日期为2024年3月1日
  const minDate = new Date(2026, 0, 1); // 月份是从0开始的，所以2代表3月
  // 设置最大日期为当前日期
  const maxDate = new Date(); // 获取当前日期和时间
  function getDates() {
    const date = new Date();
    param.tyear = date.getFullYear();
    param.tmonth = date.getMonth() + 1;
    param.year = date.getFullYear();
    param.month = date.getMonth() + 1;
    param.year1 = date.getFullYear();
    param.month1 = date.getMonth() + 1;
    setParam({ ...param });
    setMaskShow(true);
    setMaskShow2(true);
    getKeyCusHeader(timeType, targetId);
    getKeyCusList(timeType, targetId);
    getExpense(timeType);
  }
  /**
   * 关闭弹窗
   */
  function handleCancel() {
    // setIsModalOpen(false);
    setIsModalOpen(false);
  }
  /**
   * 重点客户
   */
  async function getKeyCusHeader(type, targetId) {
    const res = await key_cus_header({
      Y: param.year,
      m: param.month,
      type: type === "按月" ? 1 : 2,
      target_id: targetId,
      username,
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      param.year4 = param.year;
      param.month4 = param.month;
      setParam({ ...param });
      setCusHeader(res.data.data);
      initChChart4(res.data.data.month_proportion);
      initLrChart4(res.data.data.year_proportion);
    }
    setMaskShow(false);
  }
  async function getKeyCusList(type, targetId) {
    // 取消上一个请求
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // 创建新的 AbortController
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const res = await key_cus_list({
      Y: param.year,
      m: param.month,
      type: type === "按月" ? 1 : 2,
      target_id: targetId,
      signal: controller.signal,
      username,
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      setTimeType(type);
      setCuList(res.data.data);
      setMaskShow2(false);

      // 显示水印操作
      if (res.data.data.watermark === 1) {
        watermark(res.data.data.user_name);
      }
    }
  }

  const getExpense = async (type) => {
    const res = await get_expense({
      Y: param.year,
      m: param.month,
      type: type === "按月" ? 1 : 2,
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      setCostList(res.data.data);
      let costTotal = 0;
      res.data.data.forEach((item) => {
        costTotal += Number(item.money);
      });
      setCostTotal(costTotal);
    }
  };
  function initChChart4(month_proportion) {
    let num = month_proportion;
    // console.info(num, "num");
    const myChart = echarts.init(document.getElementById("cus-chart"));
    // const history = useHistory
    // 绘制图表
    const gaugeData = [
      {
        value: num,
        name: "Commonly",
        title: {
          show: false,
        },
        detail: {
          valueAnimation: true,
          // offsetCenter: ["0%", "40%"],
        },
      },
    ];
    myChart.setOption({
      series: [
        {
          type: "gauge",
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false,
          },
          // color: "#f88706",
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {
              borderWidth: 1,
            },
          },
          radius: "95%",
          axisLine: {
            lineStyle: {
              width: 10,
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            distance: 50,
          },
          data: gaugeData,
          title: {
            fontSize: 14,
          },
          detail: {
            width: 50,
            height: 20,
            fontSize: 15,
            color: "inherit",
            // borderColor: "inherit",
            offsetCenter: [0, "0%"],
            // borderRadius: 20,
            // borderWidth: 1,
            formatter: "{value}%",
          },
        },
      ],
    });
  }
  function initLrChart4(year_proportion) {
    let num = year_proportion;
    const myChart = echarts.init(document.getElementById("cus-chart2"));
    // const history = useHistory
    // 绘制图表
    const gaugeData = [
      {
        value: num,
        name: "Commonly",
        title: {
          show: false,
        },
        detail: {
          valueAnimation: true,
          // offsetCenter: ["0%", "40%"],
        },
      },
    ];
    myChart.setOption({
      series: [
        {
          type: "gauge",
          startAngle: 90,
          endAngle: -270,
          pointer: {
            show: false,
          },
          color: "#f88706",
          progress: {
            show: true,
            overlap: false,
            roundCap: true,
            clip: false,
            itemStyle: {
              borderWidth: 1,
            },
          },
          radius: "95%",
          axisLine: {
            lineStyle: {
              width: 10,
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
            distance: 50,
          },
          data: gaugeData,
          title: {
            fontSize: 14,
          },
          detail: {
            width: 50,
            height: 20,
            fontSize: 15,
            color: "#f88706",
            // borderColor: "inherit",
            offsetCenter: [0, "0%"],
            // borderRadius: 20,
            // borderWidth: 1,
            formatter: "{value}%",
          },
        },
      ],
    });
  }
  const getCusMl = async (cus_name) => {
    setName(cus_name);
    setMaskShow3(true);
    const res = await cus_ml({
      Y: param.year,
      m: param.month,
      type: timeType === "按月" ? 1 : 2,
      cus_name,
      sort_field: "",
      sort_value: "",
    });
    if (res && res.status === 200 && res.data.code >= 1) {
      if (res.data.data.data && res.data.data.data.length >= 1) {
        const list = res.data.data.list_data;
        let mltotal = 0;
        let mldjtotal = 0;
        list.forEach((item) => {
          mltotal += Number(item.ml);
          mldjtotal += Number(item.kml);
        });
        setMlData(list);
        setMlTotal(mltotal);
        setMlDjTotal(mldjtotal);
        setIsModalOpen(true);
      }
    }
    setMaskShow3(false);
  };
  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <div className="watermark"></div>
      <div style={{ position: "relative" }}>
        <Header title="品牌专项分析" icon={false} />
        <div
          style={{
            position: "fixed",
            top: "4px",
            right: "8.5rem",
            zIndex: 999,
          }}
        >
          <Segmented
            options={["按月", "按年"]}
            value={timeType}
            size="small"
            onChange={(value) => {
              setMaskShow(true);
              setMaskShow2(true);
              if (value === "按年") {
                const date = new Date();
                param.month = date.getMonth() + 1;
              }
              cusCateList.type = value;
              setTimeType(value);
              setParam({ ...param });
              setCusCateList({ ...cusCateList, type: value });
              getKeyCusList(value, targetId);
              getKeyCusHeader(value, targetId);
              getExpense(value);
              // getCusWpfl(cusCateList.cus_name, value);
            }}
          />
        </div>
        {timeType === "按月" ? (
          <div
            style={{
              position: "fixed",
              zIndex: "999",
              top: "0px",
              right: "10px",
              lineHeight: "32px",
              fontSize: "1.05rem",
            }}
            onClick={() => {
              param.pickShow = true;
              setParam({ ...param });
            }}
          >
            {param.year + "年" + param.month + "月"} <DownOutlined />
          </div>
        ) : (
          <div
            style={{
              position: "fixed",
              zIndex: "999",
              top: "0px",
              right: "10px",
              lineHeight: "32px",
              fontSize: "1.05rem",
            }}
            onClick={() => {
              param.pickShow = true;
              setParam({ ...param });
            }}
          >
            {param.year + "年"} <DownOutlined />
          </div>
        )}
      </div>
      <div
        style={{
          position: "relative",
          display: "flex",
          width: "100vw",
          right: "0vw",
        }}
      >
        {/* 重点客户 */}
        <div
          style={{
            width: "100vw",
            position: "relative",
          }}
        >
          <div
            className="category-type"
            style={{ justifyContent: "space-between" }}
          >
            {cusHeader.target_data.map((item, index) => {
              return (
                <div
                  className="category-type-item2"
                  key={index}
                  style={{
                    border:
                      targetId === item.target_id
                        ? "1px solid #5470c6"
                        : "1px solid transparent",
                    backgroundColor:
                      targetId === item.target_id
                        ? "rgba(84,112,198,0.1)"
                        : "#fff",
                  }}
                  onClick={() => {
                    if (targetId === item.target_id) return;
                    // setTimeType("按月");
                    setMaskShow(true);
                    settargetId(item.target_id);
                    getKeyCusHeader(timeType, item.target_id);
                    getKeyCusList(timeType, item.target_id);
                    getExpense(timeType);
                  }}
                >
                  <div>
                    {item.target_id === 1
                      ? "目标1"
                      : item.target_id === 2
                        ? "目标2"
                        : "目标3"}
                    ：
                    <span className="red" style={{ fontSize: "1.2rem" }}>
                      {item.target}
                    </span>
                    W
                  </div>
                  <div>
                    <span className="orange" style={{ fontSize: "1rem" }}>
                      {item.proportion}%
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ marginTop: "calc(2.1rem + 70px)", textAlign: "left" }}>
            <div className="ipd">
              <div className="ipd-title">
                <div className="ipd-title-name">
                  <div className="ipd-title-bz"></div>
                  品牌专项实时运营数据
                </div>
                <div>数据时间：{cusHeader.data_time}</div>
              </div>
              <div className="ipd-data">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "left",
                    fontSize: "0.8rem",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <span
                      style={{
                        fontSize: "0.9rem",
                        color: "#5470c6",
                        fontWeight: "600",
                      }}
                    >
                      {cusHeader.month_gross_margin}
                    </span>
                    万元
                  </div>
                  <div id="cus-chart"></div>
                  <div>
                    本月
                    {targetId === 1
                      ? "目标1"
                      : targetId === 2
                        ? "目标2"
                        : "目标3"}
                    完成率
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "left",
                    fontSize: "0.8rem",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <span
                      className="orange"
                      style={{ fontSize: "0.9rem", fontWeight: "600" }}
                    >
                      {cusHeader.year_gross_margin}
                    </span>
                    万元
                  </div>
                  <div id="cus-chart2"></div>
                  <div>
                    本年
                    {targetId === 1
                      ? "目标1"
                      : targetId === 2
                        ? "目标2"
                        : "目标3"}
                    完成率
                  </div>
                </div>
                <div>
                  <div style={{ marginTop: "0rem" }}>
                    <div>
                      <span
                        style={{
                          padding: "4px",
                          backgroundColor: "#6090ed",
                          display: "inline-block",
                          marginRight: "0.2rem",
                        }}
                      ></span>
                      本月毛利
                    </div>
                    <div
                      style={{
                        lineHeight: "2rem",
                        paddingLeft: "calc(0.2rem + 8px)",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "700",
                          paddingRight: "0.2rem",
                          lineHeight: "1rem",
                        }}
                        className="blue"
                      >
                        {cusHeader.month_profit}
                      </span>
                      万元
                    </div>
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <div>
                      <span
                        style={{
                          padding: "4px",
                          backgroundColor: "#ff9f18",
                          display: "inline-block",
                          marginRight: "0.2rem",
                        }}
                      ></span>
                      本年毛利
                    </div>
                    <div
                      style={{
                        lineHeight: "2rem",
                        paddingLeft: "calc(0.2rem + 8px)",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "700",
                          paddingRight: "0.2rem",
                        }}
                        className="orange"
                      >
                        {cusHeader.year_profit}
                      </span>
                      万元
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "10px" }}>
                <Segmented
                  options={["销售明细", "费用明细"]}
                  value={salesCost}
                  onChange={(value) => {
                    setSalesCost(value);
                    // cusCateList.type = value;
                    // getCusWpfl(cusCateList.cus_name, value);
                  }}
                />
              </div>
              {salesCost === "销售明细" ? (
                <div className="ipd-table">
                  <table>
                    <thead>
                      <tr>
                        <td>客户名</td>
                        <td>
                          出货量<br></br>(kg)
                        </td>
                        <td>
                          毛利<br></br>(万元)
                        </td>
                        <td>
                          毛利单价<br></br>(元/g)
                        </td>
                      </tr>
                    </thead>
                    {maskShow2 ? (
                      <tbody>
                        <tr>
                          <td colSpan={4}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <SpinLoading />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        {cusList.data.map((item, index) => (
                          <tr key={index}>
                            <td
                              onClick={() => {
                                cusCateList.cus_name = item.name;
                                navigator(
                                  "/categoryCustom/salesDetails?cus_name=" +
                                    item.name +
                                    "&type=" +
                                    cusCateList.type +
                                    "&i=" +
                                    username,
                                  {
                                    state: {
                                      year: param.year,
                                      month: param.month,
                                    },
                                  },
                                );
                              }}
                            >
                              <span
                                className="blue"
                                style={{ borderBottom: "1px solid #6090ed" }}
                              >
                                {item.name}
                              </span>
                            </td>
                            <td>{Number(item.shipment_volume).toFixed(2)}</td>
                            <td>
                              <div>{Number(item.gross_margin).toFixed(2)}</div>
                            </td>
                            <td>
                              <span
                                style={{
                                  fontWeight: 600,
                                  borderBottom: "1px solid #000",
                                }}
                                onClick={() => {
                                  // setIsModalOpen(true)
                                  setItems(item);
                                  getCusMl(item.name);
                                }}
                              >
                                {Number(item.unit_gross_margin).toFixed(2)}
                              </span>
                            </td>
                          </tr>
                        ))}
                        <tr style={{ backgroundColor: "#FFF4E7" }}>
                          <td style={{ fontWeight: "600" }}>合计</td>
                          <td
                            style={{ fontWeight: "600", fontSize: "1rem" }}
                            className="red"
                          >
                            {Number(cusList.total_shipment_volume).toFixed(2)}
                          </td>
                          <td
                            style={{ fontWeight: "600", fontSize: "1rem" }}
                            className="red"
                          >
                            {Number(cusList.total_gross_margin).toFixed(2)}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              ) : (
                <div className="ipd-table">
                  <table>
                    <thead>
                      <tr>
                        <td>费用名称</td>
                        <td>金额 (万元)</td>
                      </tr>
                    </thead>
                    <tbody>
                      {costList.map((item, index) => (
                        <tr key={index}>
                          <td>{item.expense_type}</td>
                          <td>{item.money}</td>
                        </tr>
                      ))}

                      <tr style={{ backgroundColor: "#FFF4E7" }}>
                        <td style={{ fontWeight: "600" }}>总费用</td>
                        <td
                          style={{ fontWeight: "600", fontSize: "1rem" }}
                          className="red"
                        >
                          {Number(costTotal).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={name + "毛利单价明细"}
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
      >
        {/* <Segmented
          options={["按月", "按年"]}
          value={cusCateList.type}
          onChange={(value) => {
          }}
        /> */}
        <div style={{ textAlign: "left" }}>
          <div style={{ width: "calc(100%)" }}>
            <div>
              <span className="gray">出货量：</span>
              <span style={{ fontSize: "1rem", fontWeight: 600 }}>
                {Number(items.shipment_volume).toFixed(2)}
              </span>
              kg
              <span style={{ paddingLeft: "20px" }}>
                <span className="gray">毛利：</span>
              </span>
              <span style={{ fontSize: "1rem", fontWeight: 600 }}>
                {Number(items.gross_margin).toFixed(2)}
              </span>
              万元
            </div>
            <div>
              <span>
                <span className="gray">毛利单价：</span>
              </span>
              <span style={{ fontSize: "1rem", fontWeight: 600 }}>
                {Number(items.unit_gross_margin).toFixed(2)}
              </span>
              元/g
            </div>

            <div className="ipd-table">
              <table>
                <thead>
                  <tr>
                    <td>类型</td>
                    <td>毛利 (万元)</td>
                    <td>毛利单价 (元/g)</td>
                  </tr>
                </thead>
                <tbody>
                  {mlData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{Number(item.ml / 10000).toFixed(2)}</td>
                      <td>{item.kml}</td>
                    </tr>
                  ))}
                  <tr style={{ backgroundColor: "#FFF4E7" }}>
                    <td style={{ fontWeight: "600" }}>合计</td>
                    <td
                      style={{ fontWeight: "600", fontSize: "1rem" }}
                      className="red"
                    >
                      {(mlTotal / 10000).toFixed(2)}
                    </td>
                    <td
                      style={{ fontWeight: "600", fontSize: "1rem" }}
                      className="red"
                    >
                      {mlDjTotal.toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
      <Mask visible={maskShow} color="white">
        <div className="overlayContent">
          <SpinLoading color="primary" />
        </div>
      </Mask>
      <Mask visible={maskShow3} color="white">
        <div className="overlayContent">
          <SpinLoading color="primary" />
        </div>
      </Mask>
      <DatePicker
        visible={cusCateList.type === "按月" && param.pickShow}
        onClose={() => {
          param.pickShow = false;
          setParam({ ...param });
        }}
        precision="month"
        min={minDate}
        max={maxDate}
        onConfirm={(val) => {
          param.year = val.getFullYear();
          param.month = val.getMonth() + 1;
          param.pickShow = false;
          setParam({ ...param });
          setMaskShow(true);
          setMaskShow2(true);
          if (types === 4) {
            getKeyCusHeader(timeType, targetId);
            getKeyCusList(timeType, targetId);
            getExpense(timeType);
          }
        }}
      />
      <DatePicker
        visible={cusCateList.type === "按年" && param.pickShow}
        onClose={() => {
          param.pickShow = false;
          setParam({ ...param });
        }}
        precision="year"
        min={minDate}
        max={maxDate}
        onConfirm={(val) => {
          param.year = val.getFullYear();
          // param.month = val.getMonth() + 1;
          param.pickShow = false;
          setParam({ ...param });
          setMaskShow(true);
          setMaskShow2(true);
          if (types === 4) {
            getKeyCusHeader(timeType, targetId);
            getKeyCusList(timeType, targetId);
            getExpense(timeType);
          }
        }}
      />
    </div>
  );
}
